import axios from "axios";
let URL = process.env.REACT_APP_PERMIT 

const axiosPermitURL = axios.create({baseURL:URL})

export const GetPermitByBasicIDAPI = async(data) =>{
return( await axiosPermitURL.get("/Master/GetPermitByBasicID",{ 
    params : data,
    paramsSerializer : {indexes : true}
})).data
} 